import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advisor-results-summary',
  templateUrl: './advisor-results-summary.component.html',
  styleUrls: ['./advisor-results-summary.component.scss']
})
export class AdvisorResultsSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
